import { render, staticRenderFns } from "./SOS.vue?vue&type=template&id=cbb42ed2&scoped=true"
import script from "./SOS.vue?vue&type=script&lang=js"
export * from "./SOS.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SOS.vue?vue&type=style&index=1&id=cbb42ed2&prod&scoped=true&lang=css"
import style2 from "./SOS.vue?vue&type=style&index=2&id=cbb42ed2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb42ed2",
  null
  
)

export default component.exports